import { Tag } from 'antd';
import type { Status } from '@/entities/user/model/userSchema';
import s from './StatusBadge.module.scss';

const colorMap: Record<Status | 'default', string> = {
  ok: 'success',
  warn: 'warning',
  err: 'error',
  info: 'processing',
  default: 'default',
};

interface Props {
  status: Status | 'default';
  label?: string;
  compact?: boolean;
}

export function StatusBadge({ status, label, compact }: Props) {
  return (
    <Tag
      color={colorMap[status] ?? 'default'}
      className={compact ? `${s.root__badge} ${s['root__badge_compact']}` : s.root__badge}
    >
      {label ?? status}
    </Tag>
  );
}
